import { ENDPOINTS } from "config/endpoints";
import { useMutation, useQueryClient } from "react-query";
import Error from "types/error";
import client from "utils/client";
import { Request } from "types/request";
import { Response } from "types/response";
import { generatePath } from "react-router-dom";

export default function useDeleteCollection() {
  const queryClient = useQueryClient();

  const deleteCollection = (id: string) => {
    const request: Request = {
      url: generatePath(ENDPOINTS.collections.one, { id }),
      config: {
        method: "delete",
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<Response<null>, Error, string>(deleteCollection, {
    onSettled: (data, error, id) => {
      queryClient.invalidateQueries([ENDPOINTS.collections.one, id]);
      queryClient.invalidateQueries([ENDPOINTS.collections.all]);
    },
  });

  return { data, mutate, ...rest };
}
